import { message } from 'antd'
import { ReportsApi } from '../../../api/Corporates/Reports'
import Management from '../../../components/Corporate/Report/Management'
import { checkForm } from '../../../modules/Utils'
import React, { useState } from 'react'

Management.propTypes = {}

function ManagementCont(props) {
  const formRef = React.createRef()
  const [submitting, setSubmitting] = useState(false)
  const [list, setList] = useState({ data: [], periods: [] })

  async function submit() {
    let newObject = await checkForm(formRef)
    newObject.companyList = newObject.companyList || []
    console.log(newObject)
    setSubmitting(true)
    try {
      const data = await ReportsApi.managementByYear(newObject)
      setSubmitting(false)
      setList(data)
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      setSubmitting(false)
    }
  }

  return (
    <Management
      ref={formRef}
      {...{
        list,
        submitting,
        submit,
        formRef,
      }}
    />
  )
}

export default ManagementCont
